const formatCustomText = (text: string, inline?: boolean) => {
  return text
    .replace(/\\n/g, inline ? "" : "<br />")
    .replace(/\*\*\s*(.*?)\s*\*\*/g, inline ? "$1" : "<strong>$1</strong>");
};
export default formatCustomText;
